// StatCard.tsx

import { Divider } from "../Catalyst/divider";

interface StatCardProps {
  title: string;
  description: string;
  value: string | number;
  valueLabel: string;
}

const StatCard = ({ title, description, value, valueLabel }: StatCardProps) => {
  return (
    <div className="min-h-[175px] w-full rounded-lg border-2 border-shadowborder pt-4 pb-4">
      <div className="desktext11 pl-6 text-texthead">{title}</div>
      <div className="pl-6 mt-1 font-inter text-sm font-normal leading-5 text-text-tertiary-600">{description}</div>
      <div className="my-[17px]">
        <Divider />
      </div>
      <div className="pl-6 desktext10">
        <span>{value}</span>
        <span className="text-neutral400"> {valueLabel}</span>
      </div>
    </div>
  );
};

export default StatCard;
